export const listProductFeatures = `
   query listProductFeatures($filter: ProductFeaturesFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listProductFeatures(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              name
              description
              category
              status
              createdByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getProduct = `
   query getProductFeature($id:ID!) {
       getProductFeature(id:$id) {
        id
        name
        description
        category
        status
        createdByUsername
        createdByUser {
          name
          givenName
          familyName
          email
        }
        created
        updated
       } 
}`;
